/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * product image details
 * @export
 * @interface ProductImageDetails
 */
export interface ProductImageDetails {
    /**
     * 
     * @type {string}
     * @memberof ProductImageDetails
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductImageDetails
     */
    imageName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductImageDetails
     */
    tenant?: string;
}

/**
 * Check if a given object implements the ProductImageDetails interface.
 */
export function instanceOfProductImageDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductImageDetailsFromJSON(json: any): ProductImageDetails {
    return ProductImageDetailsFromJSONTyped(json, false);
}

export function ProductImageDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductImageDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'imageName': !exists(json, 'imageName') ? undefined : json['imageName'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
    };
}

export function ProductImageDetailsToJSON(value?: ProductImageDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'imageName': value.imageName,
        'tenant': value.tenant,
    };
}

